import { useEffect } from "react";
import React from "react";
import "./App.css";
import RouteComponent from "./routes/Route";


function App() {

//   useEffect(() => {
//   const disableRightClick = (e) => e.preventDefault();
//   document.addEventListener("contextmenu", disableRightClick);

//   return () => {
//     document.removeEventListener("contextmenu", disableRightClick);
//   };
// }, []);



  return (

        <RouteComponent />
      
  );
}

export default App;
